import InputField from 'components/form-fields/formik/InputField';
import { Formik } from 'formik';
import React from 'react';
import {
  Container,
  Divider,
  Form,
  Header,
  Button,
  Message,
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'types/provider';
import { request } from 'utils/api';
import CheckboxField from 'components/form-fields/formik/CheckboxField';
import styles from './Settings.module.css';

const SettingsRoaming: React.FC<{
  provider: Partial<Provider>;
}> = ({ provider }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h2" style={{ padding: '0', margin: '0' }}>
        {t('editSandboxRoaming.title', 'Roaming')}
      </Header>
      <Divider />
      <p>{t('editSandboxRoaming.description', 'Roaming settings')}</p>
      <Formik
        enableReinitialize
        initialValues={{
          enableSubOperatorName: provider.enableSubOperatorName,
          roamingSubOperatorName: provider.roamingSubOperatorName,
          enableCustomPartyIds: provider.enableCustomPartyIds,
          customPartyId: provider.customPartyId,
        }}
        onSubmit={(values) => {
          request({
            method: 'PATCH',
            path: `/1/sandboxes/${(provider as any)._id}/settings`,
            body: {
              ...provider,
              ...values,
            },
          });
        }}>
        {({ handleSubmit, values, isSubmitting, isValid, dirty }) => {
          return (
            <Form>
              <Form.Field className={styles.productProposition}>
                <CheckboxField
                  toggle
                  label={t(
                    'editSandboxRoaming.enableSuboperatorName',
                    'Enable default suboperator name'
                  )}
                  name="enableSubOperatorName"
                />
                <Message info>
                  Allows configuration of default suboperator name for OCPI
                  protocol compliance and partner integrations.
                </Message>
                {values.enableSubOperatorName && (
                  <InputField
                    name="roamingSubOperatorName"
                    label={t(
                      'editSandbox.roamingSuboperatorName',
                      'Suboperator name'
                    )}
                  />
                )}
              </Form.Field>
              <Form.Field className={styles.productProposition}>
                <CheckboxField
                  toggle
                  label={t(
                    'editSandboxRoaming.enableCustomPartyIds',
                    'Enable Custom Party IDs'
                  )}
                  name="enableCustomPartyIds"
                />
                <Message info>
                  {t(
                    'editSandboxRoaming.enableCustomPartyIdsInfo',
                    'Allows configuration of custom party identifiers for OCPI protocol compliance and partner integrations.'
                  )}
                </Message>
                {values.enableCustomPartyIds && (
                  <InputField
                    name="customPartyId"
                    label={t(
                      'editSandboxRoaming.customPartyId',
                      'Custom Party ID'
                    )}
                  />
                )}
              </Form.Field>
              <Button
                disabled={isSubmitting || !isValid}
                onClick={() => handleSubmit()}
                primary>
                {t('save', 'Save')}
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default SettingsRoaming;
